"use strict";

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.CategoryTranslationReducer = exports.CategoryReducer = undefined;

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

exports.reduceCategories = reduceCategories;

var _nodeToolbox = require("@esnpm/node-toolbox");

var _translate = require("@esnpm/translate");

var _apiCategory = require("../actions/esdb/apiCategory");

var _apiCategoryBreadCrumbs = require("../actions/esdb/apiCategoryBreadCrumbs");

function reduceCategories(state, payload) {
	var newState = Object.assign({}, state, {
		data: Object.assign({}, state.data),
		loading: payload.loading,
		error: payload.error
	});

	// ANGEPACKT: FINGER AB!!

	Object.entries(payload.data).map(function (_ref) {
		var _ref2 = _slicedToArray(_ref, 2),
		    k = _ref2[0],
		    v = _ref2[1];

		var newv = Object.assign({}, v);
		if (!newv.hasOwnProperty('CHILDREN')) {
			newv.CHILDREN = [];
		}
		if (newv.HAS_CHILDREN && newv.CHILDREN.length == 0) {
			// newv hat keine children data aber has_children = true

			// children daten übermnehmen aus store falls vorhanden
			if (newState.data[k] != undefined && newState.data[k].CHILDREN != undefined) {
				newv.CHILDREN = newState.data[k].CHILDREN;
			} else {
				newv.CHILDREN = [];
			}
		}
		newState.data[k] = newv;
	});
	return newState;
}

var CategoryReducer = exports.CategoryReducer = function CategoryReducer() {
	var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
		data: {},
		loading: false,
		error: null
	};
	var action = arguments[1];


	switch (action.type) {
		case _apiCategory.API_CATEGORY_SUCCESS:
		case _apiCategoryBreadCrumbs.API_CATEGORY_BREAD_CRUMBS_SUCCESS:

			// let newState = Object.assign({}, state, {
			//     loading: action.payload.loading,
			//     error: action.payload.error,
			//     data: Object.assign({},state.data)
			// });
			//
			// Object.entries(action.payload.data).map(([k,v]) => {
			//     newState.data[k] = v;
			// });
			// return newState;
			// break;
			return reduceCategories(state, action.payload);
			break;

		default:
			return state;
	}
};

var CategoryTranslationReducer = exports.CategoryTranslationReducer = function CategoryTranslationReducer() {
	var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
		loading: false,
		data: null,
		error: null
	};
	var action = arguments[1];

	switch (action.type) {
		case _apiCategory.API_CATEGORY_SUCCESS:
		case _apiCategoryBreadCrumbs.API_CATEGORY_BREAD_CRUMBS_SUCCESS:

			// let newState = registerTranslation(state, "categories", action.payload.data);
			// return newState;

			var newState = Object.assign({}, state);

			Object.values(action.payload.data).map(function (v) {

				var s = 'categories.' + v.PATH + '.NAME';

				newState = (0, _translate.registerTranslation)(newState, s, v.NAME);
			});

			return newState;
			break;

		default:
			return state;
	}
};